import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const content = [
    {
        logo: require('./../../images/client-logo/logo-2.png'),
    },
    {
        logo: require('./../../images/client-logo/cropped-gujrat-technocasting-logo-small-1.png'),
    },
    {
        logo: require('./../../images/client-logo/logo.png'),
    },
    {
        logo: require('./../../images/client-logo/Kishorpump.png'),
    },
    {
        logo: require('./../../images/client-logo/Sensitivefoundry.png'),
    },
    {
        logo: require('./../../images/client-logo/pnp.png'),
    },
    {
        logo: require('./../../images/client-logo/UNIQUEFERROCAST.png'),
    },
    {
        logo: require('./../../images/client-logo/KELSTON.png'),
    },
]


class ClientSlider1 extends Component {

    render() {

        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,           // Enable autoplay
            autoplaySpeed: 2000,      // Adjust the speed (2000ms = 2 seconds)
			responsive: [
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 4
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 2
				  }
				}
			]
        };

        const Border = this.props.hideBorder ? "" : "border";
        const padding = this.props.allowPadding ? "p-a25" : "";

        return (
            <>
                <Slider {...settings} className="client-logo-carousel btn-style-1 icon-2">
                    {content.map((item, id) => (
                        <div key={id} className="item">
                            <div className={`ow-client-logo ${padding}`}>
                                <div className={`client-logo ${Border}`}>
                                    <Link to="#"><img src={item.logo} alt=""/></Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </>
        );
    }
}

export default ClientSlider1;
